import React, { useState } from 'react';

const SearchBar = ({ onSearch, placeholder = "Search products..." }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(searchTerm.trim());
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <form onSubmit={handleSubmit} style={{ position: 'relative', width: '100%', maxWidth: '500px' }}>
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          value={searchTerm}
          onChange={handleInputChange}
          placeholder={placeholder}
          style={{
            width: '100%',
            paddingLeft: '3.25rem',
            paddingRight: searchTerm ? '3.5rem' : '1.25rem',
            paddingTop: '1rem',
            paddingBottom: '1rem',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '1.75rem',
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(15px)',
            fontSize: '1rem',
            fontWeight: '500',
            color: '#2C2C2C',
            outline: 'none',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.12)'
          }}
          onFocus={(e) => {
            e.target.style.border = '2px solid rgba(30, 64, 175, 0.8)';
            e.target.style.background = 'rgba(255, 255, 255, 1)';
            e.target.style.boxShadow = '0 12px 32px rgba(30, 64, 175, 0.2)';
            e.target.style.transform = 'translateY(-3px)';
          }}
          onBlur={(e) => {
            e.target.style.border = '2px solid rgba(255, 255, 255, 0.3)';
            e.target.style.background = 'rgba(255, 255, 255, 0.95)';
            e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
            e.target.style.transform = 'translateY(0)';
          }}
        />
        
        {/* Enhanced Search Icon */}
        <div style={{
          position: 'absolute',
          top: '50%',
          left: '1rem',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: '#6b7280',
          fontSize: '1.25rem'
        }}>
          🔍
        </div>

        {/* Enhanced Clear Button */}
        {searchTerm && (
          <button
            type="button"
            onClick={handleClear}
            style={{
              position: 'absolute',
              top: '50%',
              right: '1rem',
              transform: 'translateY(-50%)',
              background: 'rgba(30, 64, 175, 0.1)',
              border: 'none',
              borderRadius: '50%',
              width: '2rem',
              height: '2rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#1E40AF',
              cursor: 'pointer',
              fontSize: '0.875rem',
              fontWeight: '600',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(30, 64, 175, 0.2)';
              e.target.style.transform = 'translateY(-50%) scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(30, 64, 175, 0.1)';
              e.target.style.transform = 'translateY(-50%) scale(1)';
            }}
          >
            ✕
          </button>
        )}
      </div>

      {/* Enhanced Submit Button (Hidden but functional) */}
      <button
        type="submit"
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none'
        }}
        aria-hidden="true"
      >
        Search
      </button>
    </form>
  );
};

export default SearchBar;
